import {
  ChildrenFeature as childrenReducer,
  ChildrenPayload,
  setChildrenAction,
} from '@smartsheet-dataflow/formjs';
import { BridgeFormJSState } from '../../Types';
import { dummyDispatch } from '../ParamFromSchema';

export const reduceChildren =
  (payload: ChildrenPayload) => (state: BridgeFormJSState) =>
    childrenReducer(state, setChildrenAction(dummyDispatch)(payload));
